import React, { useState } from "react";
import { Grid, Tabs, Tab, styled } from "@mui/material";

import { APIBilling } from "../../../../api";
import ChargesOverTime from "../ChargesOverTime/ChargesOverTime";
import ReportChartWithDateSelect from "../ReportChartsWithDateSelect/ReportChartWithDateSelect";
import NetSalesCalculator from "../NetSalesCalculator";
import ProductsStatistic from "../ProductsStatistic";
import SalesSection from "../SalesSection";
import SalesResultsInScales from "../SalesResultsInScales";
import { BROKER_TAB } from "../../constants";

const StyledTab = styled((props: { value: string; label: string }) => <Tab {...props} />)(() => ({
  padding: "3px 6px",
  minWidth: "auto",
  minHeight: 38,
}));

const TabSalesStats: React.FC = () => {
  const [plansBroker, setPlansBroker] = useState(BROKER_TAB.combined);

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ChargesOverTime />
        </Grid>
      </Grid>

      <SalesResultsInScales />

      <Grid container spacing={3}>
        <Grid item xs={6}>
          <h2>Sum of all payments</h2>
          <div>
            <ReportChartWithDateSelect
              getReportRequest={APIBilling.getReportRequest}
              type="sum"
              purchaseStatus="accepted"
            />
          </div>
        </Grid>

        <Grid item xs={6}>
          <h2>Plans purchased</h2>
          <Tabs
            value={plansBroker}
            onChange={(_, v: BROKER_TAB) => setPlansBroker(v)}
            centered
            sx={{ mb: 1 }}
          >
            <StyledTab value={BROKER_TAB.combined} label="Combined" />
            <StyledTab value={BROKER_TAB.tradovate} label="Tradovate" />
            <StyledTab value={BROKER_TAB.rithmic} label="Rithmic" />
          </Tabs>
          <div>
            <ReportChartWithDateSelect
              getReportRequest={APIBilling.getReportRequest}
              isShowList
              type="purchased"
              purchaseStatus="accepted"
              broker={plansBroker}
            />
          </div>
        </Grid>
      </Grid>
      <NetSalesCalculator />
      <SalesSection />
      <ProductsStatistic />
    </div>
  );
};

export default TabSalesStats;
